module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goBack":"Go back","goToPanel":"Go to panel"}}')
  delete Component.options._Ctor
}
